import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-total-sortie',
    templateUrl: './total-sortie.component.html',
    styleUrls: ['./total-sortie.component.scss']
})
export class TotalSortieComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public authenticationService: AuthenticationService,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
    }
}
